import { ComponentProps } from 'react';
import Icon from '@amzn/meridian/icon';
import useActionButtonStyles from '../hooks/useActionButtonStyles';

interface IconButtonProps {
  iconTokens: ComponentProps<typeof Icon>['tokens'];
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export default function IconButton({ iconTokens, label, onClick, disabled = false }: IconButtonProps) {
  const { iconButtonClass } = useActionButtonStyles();

  return (
    <button
      type="button"
      className={iconButtonClass}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      <Icon tokens={iconTokens} />
    </button>
  );
}
